import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import H2 from 'UIComponents/elements/headings/H2';
import UIIcon from 'UIComponents/icon/UIIcon';
import { LORAX } from 'HubStyleTokens/colors'; //@ts-expect-error Could not find declaration file for module

import useMediaQuery from '../hooks/useMediaQuery';
import { device } from '../constants/StyledComponentConstants';
import H4 from 'UIComponents/elements/headings/H4';
import styled, { css, mediaQuery } from '../utils/Styling';
const DesktopTitle = styled(H2).withConfig({
  displayName: "SectionHeading__DesktopTitle",
  componentId: "sc-15hi7ps-0"
})(["font-weight:400;"]);
const MobileTitle = styled(H4).withConfig({
  displayName: "SectionHeading__MobileTitle",
  componentId: "sc-15hi7ps-1"
})(["font-weight:400;"]);
const SubText = styled.div.withConfig({
  displayName: "SectionHeading__SubText",
  componentId: "sc-15hi7ps-2"
})(["margin-top:4px;margin-bottom:12px;", ""], mediaQuery('mobile', css(["margin-top:8px;"])));

const SectionHeading = ({
  children,
  className,
  icon,
  subText
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const TitleComponent = isMobile ? MobileTitle : DesktopTitle;
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(TitleComponent, {
      className: `${className} m-bottom-1 m-right-2`,
      style: {
        display: 'inline-block'
      },
      children: children
    }), icon && /*#__PURE__*/_jsx(UIIcon, {
      color: LORAX,
      name: "certification",
      size: isMobile ? 18 : 20
    }), subText && /*#__PURE__*/_jsx(SubText, {
      children: subText
    })]
  });
};

export default SectionHeading;